import type { ConversationEventResponse, MessageResponse } from '../api/types';

/** One line in a thread: a message, or one of the reader's notifications about the child. */
export type TimelineItem =
  | { kind: 'message'; at: string; message: MessageResponse }
  | { kind: 'event'; at: string; event: ConversationEventResponse };

/**
 * Messages and events in one list, oldest first (decision 2026-09-23 #24).
 *
 * Both lists arrive oldest first. Where a message and an event share an instant, the message comes first:
 * it is what the reader opened the thread to read.
 */
export function mergeTimeline(
  messages: readonly MessageResponse[],
  events: readonly ConversationEventResponse[],
): TimelineItem[] {
  const items: TimelineItem[] = [
    ...messages.map((message) => ({ kind: 'message' as const, at: message.sentAt, message })),
    ...events.map((event) => ({ kind: 'event' as const, at: event.at, event })),
  ];

  // Array.prototype.sort is stable, so equal instants keep the order above: messages before events.
  return items.sort((a, b) => Date.parse(a.at) - Date.parse(b.at));
}
